import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { AbstractSessionService } from '../abstraction/abstract.session.service';

@Injectable({
  providedIn: 'root',
})
export class SessionService extends AbstractSessionService {
  controller = `/manager/session`;
  urlPostLogout = `${environment.apiUrl}${this.controller}/logout`;
  urlGetFedNowTransactionDualApprovalWorkflowEnabled = `${environment.apiUrl}${this.controller}/fednow/transactiondualapprovalworkflowenabled`;

  constructor(private http: HttpClient) {
    super();
  }

  logout(): Promise<void> {
    return this.http.post<void>(this.urlPostLogout, {}).toPromise();
  }

  /**
   * Returns whether the FedNow Transaction Dual Approval Workflow configuration should be
   * allowed to be displayed to the logged on user (if they have entitlements to configure FedNow).
   */
  getFedNowTransactionDualApprovalWorkflowConfigEnabled(): Promise<boolean | undefined> {
    return this.http
      .get<boolean>(this.urlGetFedNowTransactionDualApprovalWorkflowEnabled)
      .toPromise();
  }
}
